import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

/**
 * Custom toast component
 */
@Component({
  selector: 'app-pco-toast',
  templateUrl: './pco-toast.component.html',
  standalone: true,
  imports: [ToastModule, PrimeTemplate, NgClass, NgIf, NgFor],
})
export class PcoToastComponent {}
